import MegaMenuVideos from './MegaMenuVideos'

export default class MegaMenu {
  constructor() {
    this.megaMenu = document.querySelector('.megaMenu')

    if (!this.megaMenu) return

    this.megaMenuNav = this.megaMenu.querySelector('.megaMenu__nav')
    this.megaMenuNavItems = this.megaMenuNav.querySelectorAll('.megaMenu__nav-item')
    this.megaMenuTabs = this.megaMenu.querySelectorAll('.megaMenuTab')
    this.itemWidth = 0
    this.leftPosition = 0

    window.addEventListener('resize', () => {
      const activeElement = [...this.megaMenuNavItems].find((item) => {
        return item.classList.contains('is-active')
      })
      if (activeElement) {
        this.setAfterPosition(activeElement)
      }
    })

    window.addEventListener('DOMContentLoaded', () => {
      this.handleTabChange()
      new MegaMenuVideos(this.megaMenu)
      setTimeout(() => {
        this.setInitialAfterPosition()
      }, 500)
    })
  }

  setInitialAfterPosition() {
    const item = this.megaMenuNavItems[0]
    this.setAfterPosition(item)
  }

  handleTabChange() {
    this.megaMenuNavItems.forEach((item) => {
      item.addEventListener('click', () => {
        this.megaMenuNavItems.forEach((item) => {
          item.classList.remove('is-active')
        })
        item.classList.add('is-active')

        this.setAfterPosition(item)
        this.switchTab([...this.megaMenuNavItems].indexOf(item))
      })
    })
  }

  switchTab(index) {
    const selectedTab = [...this.megaMenuTabs][index]
    const otherTabs = [...this.megaMenuTabs].filter((el) => {
      const tabIndex = [...this.megaMenuTabs].indexOf(el)
      return tabIndex !== index
    })

    selectedTab.classList.add('active')
    this.hideOtherTabs(otherTabs)
  }

  hideOtherTabs(tabs) {
    tabs.forEach((tab) => {
      tab.classList.remove('active')
    })
  }

  setAfterPosition(item) {
    this.itemWidth = item.offsetWidth
    this.leftPosition = item.getBoundingClientRect().left - this.megaMenuNav.getBoundingClientRect().left
    this.megaMenuNav.style.setProperty('--after-width', this.itemWidth + 'px')
    this.megaMenuNav.style.setProperty('--after-left-position', this.leftPosition + 'px')
  }
}
